<template>
  <el-card class="h-full">
    <el-table :data="tableData" height="100%" border>
      <el-table-column label="序号" width="40">
        <template slot-scope="scope">
          <span>{{ scope.row.idx }}</span>
        </template>
      </el-table-column>
      <el-table-column label="类型" width="70">
        <template slot-scope="scope">
          <span>{{ scope.row.typeName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="ID" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="模块名" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="版本" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.version }}</span>
        </template>
      </el-table-column>
      <el-table-column label="描述">
        <template slot-scope="scope">
          <span>{{ scope.row.description }}</span>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
    }
  },
  computed: {},
  methods: {},
  mounted() {
    let i = 0
    const addTableData = (insts) => {
      const typeMap = { module: '模块', auth: '认证', layout: '布局' }
      Object.keys(insts).forEach((name) => {
        const inst = insts[name]
        const typeKey = inst.type ? inst.type : 'module'
        const typeName = typeMap[typeKey]
        i += 1
        this.tableData.push({
          idx: i,
          name: inst.name,
          title: inst.title,
          typeName,
          version: inst.version,
          description: inst.description,
        })
      })
    }
    addTableData(Wiz.layout.instances)
    addTableData(Wiz.auth.instances)
    addTableData(Wiz.dynamicModules.instances)
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
